import MainLayout from '../layouts/main';
import Mahak from './mahak';

function MahakPage() {
  return (
    <MainLayout loginRequired={false} studentRequired={false} title={MAHAK_PAGE_TITLE}>
      <Mahak />
    </MainLayout>
  );
}

export const MAHAK_PAGE_TITLE = 'آزمون محک آذر ماه';

export default MahakPage;
